import { Component } from '@angular/core';

@Component({
  selector: 'app-main',
  standalone: false,
  templateUrl: './app.component.html',
  host: {
    class: 'angular-component-wrapper',
  },
})
export class AppComponent {}
